import * as actions from '../actions/review.action.js';
import {default_state} from './index.js';

export function review_box(state=default_state.review_box, action={}){
    let review_box = action.review_box || {};
    let default_review_state = default_state.review_box;

    switch (action.type) {
        case actions.OPEN_REVIEWS:
            return {
                ...default_review_state
            };

        case actions.REVIEWS_DOWNLOADED:
            return {
                ...state,
                ...review_box
            };

        case actions.TOGGLE_THUMBUP:
        {
            return {
                ...state,
                thumbup: !action.is_off,
                thumbdown: !action.is_off ? false : state.thumbdown,
                thumbdown_done: !action.is_off ? false : state.thumbdown_done
            };
        }

        case actions.TOGGLE_THUMBDOWN:
        {
            return {
                ...state,
                thumbdown: !action.is_off,
                thumbup: !action.is_off ? false : state.thumbup,
                thumbdown_done: !action.is_off ? false : state.thumbdown_done
            };
        }

        case actions.THUMBDOWN_DONE:
        {
            return {
                ...state,
                thumbdown_done: !action.is_off
            };
        }

        case actions.SELECT_REASON:
            return {
                ...state,
                reason_id: action.reason_id
            };

        case actions.POST_REVIEW:
        {
            let reviewData = action.reviewData;
            let value = reviewData.reviewValue;

            // cache current user review, if it exists.
            let my_review = state.user_reviews[0];
            if (my_review && my_review.reviewValue == value) {
                return {
                    ...state
                };
            }
            let prev_reviews = {
                counts: state.counts,
                user_reviews: state.user_reviews
            };
            let user_reviews = state.user_reviews;
            let counts = state.counts;
            let new_state = {
                ...state,
                prev_reviews: {
                    ...prev_reviews
                },
                counts: {
                    ...counts
                },
                user_reviews: [
                    ...user_reviews
                ]
            };

            new_state.counts[value == '0' ? 'like' : 'dislike']++;
            // If the user already has a review, decrement.
            if (my_review) {
                new_state.counts[value == '1' ? 'like' : 'dislike']--;
            }
            new_state.user_reviews[0] = {
                reviewValue: value,
                is_posting: true
            };

            return new_state;
        }

        case actions.REVIEW_POSTED:
        {
            let my_review = state.user_reviews[0];
            let reviewData = action.reviewData;
            my_review = {
                ...reviewData,
                ...my_review,
                is_posting: false
            };

            let new_state = {
                ...state,
                user_reviews: [my_review]
            };
            delete new_state.prev_reviews;

            return new_state;
        }

        case actions.POST_REVIEW_ERROR:
        {
            let prev_reviews = state.prev_reviews;
            let new_state = {
                ...state,
                ...prev_reviews
            };
            delete new_state.prev_reviews;

            return new_state;
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/review.reducer.js